import { jsx as _jsx } from "react/jsx-runtime";
import { createContext, useMemo } from 'react';
export const defaultEvmExternalWallet = {
    wallets: [],
    chains: [],
    chainId: undefined,
    username: undefined,
    avatar: undefined,
    disconnect: () => Promise.resolve(),
    switchChain: () => Promise.resolve({}),
};
export const EvmExternalWalletContext = createContext(defaultEvmExternalWallet);
export function EvmExternalWalletProvider({ children }) {
    const wallets = [];
    const chains = [];
    const chainId = undefined;
    const username = undefined;
    const avatar = undefined;
    const disconnect = () => Promise.resolve();
    const switchChain = () => Promise.resolve({});
    return (_jsx(EvmExternalWalletContext.Provider, { value: useMemo(() => ({ wallets, chains, chainId, username, avatar, disconnect, switchChain }), [wallets, chains, chainId, username, avatar, disconnect, switchChain]), children: children }));
}
